import { MigrationManifest, PersistedState } from 'redux-persist';

/** Bump with every entry added to persistMigrations. */
export const PERSIST_VERSION = 1;

export const persistMigrations: MigrationManifest = {
  /**
   * Dark mode moved from an on/off switch on each device, where off was the default, to the
   * account, where no value follows the phone. "On" stays and is saved to the account on the next
   * connection (saveUnsavedDarkMode). "Off" is dropped, since it cannot be told apart from never
   * having chosen.
   */
  1: (state: PersistedState): PersistedState => {
    const persisted: any = state;
    if (!persisted || !persisted.user) {
      return state;
    }
    const {darkMode, ...user} = persisted.user;
    return {
      ...persisted,
      user: darkMode === true ? {...user, darkMode: true, darkModeUnsaved: true} : user,
    };
  },
};



// WEBPACK FOOTER //
// ./src/persistMigrations.ts